import { useTranslation } from 'react-i18next';
import { CourseTheatreRecipe } from 'flows/CourseTheatreRecipe';

const usePDFdetails = (lessonPathname) => {
    const { i18n } = useTranslation();
    const lesson = CourseTheatreRecipe.lessons.find(l => l.pathname === lessonPathname);
    if (!lesson) return { pdfUrl: null, thumbSrc: null };
    const { activityPagePDF, activityPageThumb } = lesson;
    const pdfUrl = i18n.language === 'he' ? activityPagePDF.replace('.pdf', '_he.pdf') : activityPagePDF;
    return { pdfUrl, thumbSrc: activityPageThumb };
};

export default usePDFdetails;
